'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InteractionTagSecondary", {
    enumerable: true,
    get: function() {
        return InteractionTagSecondary;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useInteractionTagSecondary = require("./useInteractionTagSecondary");
const _renderInteractionTagSecondary = require("./renderInteractionTagSecondary");
const _useInteractionTagSecondaryStylesstyles = require("./useInteractionTagSecondaryStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const InteractionTagSecondary = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useInteractionTagSecondary.useInteractionTagSecondary_unstable)(props, ref);
    (0, _useInteractionTagSecondaryStylesstyles.useInteractionTagSecondaryStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useInteractionTagSecondaryStyles_unstable')(state);
    return (0, _renderInteractionTagSecondary.renderInteractionTagSecondary_unstable)(state);
});
InteractionTagSecondary.displayName = 'InteractionTagSecondary';
